import MovingAverageCalculation from "./movingAverageCalculation";
import SeriesDataUpdate from "./seriesDataUpdate";

const startingPartiesIndex = 2; //Starting Parties inside Item mapping (position 2+)

const PartiesDataUpdate = (movingAverageRange, poll, index, partyDataV2, type, party) => {
        let partyPercentage = poll[Object.keys(poll)[startingPartiesIndex + index]];
        let pollDate = poll.date.day.toString() + "/" + poll.date.month.toString() + "/" + poll.date.year.toString();
        partyDataV2.lastDate = pollDate;
        partyDataV2.percentages.push(partyPercentage);

        SeriesDataUpdate(type, 'scatter', party, [pollDate, partyPercentage])

        MovingAverageCalculation(movingAverageRange, pollDate, partyDataV2, type, party);
}
export default PartiesDataUpdate;